import {
  ChangeDetectorRef,
  Component,
  inject,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { SvgIconComponent } from 'angular-svg-icon';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputGroupComponent, NzInputModule } from 'ng-zorro-antd/input';
import { NzTableModule, NzTableQueryParams } from 'ng-zorro-antd/table';
import { DrawerService } from '../../../core/services/drawer.service';
// import { TemplateLogsFilterComponent } from './template-logs-filter/template-logs-filter.component';
// import { TemplateLogDetailsComponent } from './template-log-details/template-log-details.component';
import { BipTemplateService } from '../bip-template.service';
import {
  debounceTime,
  finalize,
  Observable,
  of,
  Subject,
  take,
  takeUntil,
} from 'rxjs';
import { CommonService } from '../../../shared/services/common.service';
import { LoaderService } from '../../../core/services/loader.service';
import { ErrorResponse } from '../../../core/models/error.models';
import { CommonModule } from '@angular/common';
import { AuditType } from '../bip-template.enums';
import { TemplateLogsFilterComponent } from '../template-logs/template-logs-filter/template-logs-filter.component';
import { DRAWER_IDS } from '../../../core/constants/drawer-ids.constant';
import { DrawerParams, TemplateLogs } from '../bip-template.interface';
import { LogsQueryParams } from '../bip-template.interface';
import { TemplateLogDetailsComponent } from './template-log-details/template-log-details.component';
import { DrawerHeaderComponent } from '../../../components/drawer-header/drawer-header.component';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import {
  OrganizationDetailModel,
  userDetailModel,
} from '../../organizations/organization.interface';
import { UserDatePipe } from '../../../shared/pipes/user-date.pipe';
import { OrganizationSearchComponent } from '../../../components/organization-search/organization-search.component';
import { AuthService } from '../../../core/services/auth.service';
import { OrganizationSelectionService } from '../../../core/services/organization-selection.service';

@Component({
  selector: 'app-template-logs',
  standalone: true,
  imports: [
    NzFormModule,
    NzInputGroupComponent,
    NzInputModule,
    NzIconModule,
    NzButtonModule,
    SvgIconComponent,
    NzTableModule,
    CommonModule,
    DrawerHeaderComponent,
    ReactiveFormsModule,
    NzSpinModule,
    UserDatePipe,
    OrganizationSearchComponent,
  ],
  templateUrl: './template-logs.component.html',
  styleUrl: './template-logs.component.scss',
})
export class TemplateLogsComponent implements OnInit, OnDestroy {
  private templateService = inject(BipTemplateService);

  @ViewChild('drawerLogDetail')
  drawerLogDetail!: TemplateRef<void>;
  pageSize = 10;
  pageIndex = 1;
  totalRow = 0;
  sort = 'title';
  searchTitle = new FormControl('');
  sortOrder: number | undefined = 1;
  templateLogs$ = this.templateService.templateLogs$;
  private readonly destroy$ = new Subject<void>();
  loading$: Observable<boolean> = of(false);
  appliedFilters: DrawerParams['appliedFilters'] | null = null;
  appliedFilterLength = 0;
  AuditTypeEnums = AuditType;
  orgId = 0;
  drawerParams = {
    templateId: null,
    dataAuditTypeId: null,
    userId: null,
    dateFilter: null,
  };
  listOfColumn = [
    {
      title: 'Title',
      compare: null,
      key: 'title',
    },
    {
      title: 'Template',
      compare: null,
      key: 'templateName',
    },
    {
      title: 'Type',
      compare: null,
    },
    {
      title: 'User',
      compare: null,
      key: 'userName',
    },
    {
      title: 'Time',
      compare: null,
      key: 'time',
    },
    {
      title: 'Date',
      compare: null,
      key: 'date',
    },
    {
      title: '',
      compare: null,
    },
  ];
  orgData: OrganizationDetailModel | null = null;
  userData: userDetailModel | null = null;
  constructor(
    private drawerService: DrawerService,
    private commonService: CommonService,
    private loaderService: LoaderService,
    private cdr: ChangeDetectorRef,
    private authService: AuthService,
    private readonly orgSelectionService: OrganizationSelectionService
  ) {
    this.loading$ = this.loaderService.loading$;
    this.authService.userData$.pipe(takeUntil(this.destroy$)).subscribe(res => {
      this.userData = res;
    });
    this.drawerService
      .getPersistentState<DrawerParams>(DRAWER_IDS.TEMPLATE_LOGS_FILTER)
      .pipe(takeUntil(this.destroy$))
      .subscribe(state => {
        if (state) {
          this.appliedFilters = state.appliedFilters;
          this.appliedFilterLength = state.appliedFilterLength ?? 0;
          this.cdr.detectChanges();
        }
      });
  }

  ngOnInit(): void {
    this.orgSelectionService.orgId$
      .pipe(takeUntil(this.destroy$))
      .subscribe(orgId => {
        const newOrgId = orgId === null ? 0 : orgId;
        if (newOrgId !== this.orgId) {
          this.orgId = newOrgId;
          this.pageIndex = 1;
          this.loadData();
        }
      });

    this.searchTitle.valueChanges
      .pipe(
        takeUntil(this.destroy$),
        debounceTime(1000) // 500ms delay
      )
      .subscribe(() => {
        this.loadData();
      });
  }
  onQueryParamsChange(params: NzTableQueryParams): void {
    this.pageSize = params.pageSize;
    this.pageIndex = params.pageIndex;
    const currentSort = params.sort.find(item => item.value !== null);
    this.sort = (currentSort && currentSort.key) || '';
    this.sortOrder =
      !!currentSort && currentSort.value
        ? currentSort.value === 'ascend'
          ? 0
          : 1
        : undefined;
    this.loadData();
  }
  orgChange(value: number | null) {
    if (value === null) {
      this.orgId = 0;
    } else {
      this.orgId = value;
    }
    this.orgSelectionService.setOrgId(value);
    this.loadData();
  }

  onChange() {
    this.pageIndex = 1;
    this.loadData();
  }

  loadData(): void {
    const queryParams: LogsQueryParams = {
      pageSize: this.pageSize,
      page: this.pageIndex,
      sort: this.sort ?? undefined,
      sortOrder: this.sortOrder,
      title: this.searchTitle.value || '',
      organizationId: Number(this.orgId) || null,
      templateId: this.appliedFilters?.templateId || null,
      userId: this.appliedFilters?.userId || null,
      dataAuditTypeId: this.appliedFilters?.dataAuditTypeId || null,
      dateFilter: this.appliedFilters?.dateFilter || null,
    };
    this.loaderService.show();
    this.templateService
      .getTemplateLogs(queryParams)
      .pipe(
        take(1), // Take only one response
        finalize(() => this.loaderService.hide()), // End loading after response
        takeUntil(this.destroy$)
      )
      .subscribe({
        next: response => {
          this.totalRow = response.result.totalRows;
          this.loaderService.hide();
        },
        error: (error: ErrorResponse) => {
          this.loaderService.hide();
          this.commonService.notify('error', error.message);
        },
      });
  }

  openFilterDrawer(): void {
    this.drawerService
      .openDrawer(
        TemplateLogsFilterComponent,
        'Filter',
        780,
        true,
        undefined,
        {
          appliedFilterLength: this.appliedFilterLength,
          appliedFilters: this.appliedFilters,
          orgnizationId: this.orgId,
        },
        DRAWER_IDS.TEMPLATE_LOGS_FILTER
      )
      .afterClose.pipe(takeUntil(this.destroy$))
      .subscribe(res => {
        if (res) {
          this.loadData();
        }
      });
  }

  openTemplateLogDetailsDrawer(data: TemplateLogs): void {
    this.drawerService.openDrawer(
      TemplateLogDetailsComponent,
      this.drawerLogDetail as unknown as TemplateRef<object>,
      1170,
      true,
      undefined,
      {
        selectedLog: data,
      },
      DRAWER_IDS.TEMPLATE_LOGS_DETAIL
    );
  }

  closeLogDetailDrawer() {
    this.drawerService.closeDrawer(DRAWER_IDS.TEMPLATE_LOGS_DETAIL);
  }

  clearFilters(): void {
    this.appliedFilters = null;
    this.appliedFilterLength = 0;
    this.drawerService.clearPersistentState(DRAWER_IDS.TEMPLATE_LOGS_FILTER);
    this.loadData();
  }

  ngOnDestroy(): void {
    this.drawerService.clearPersistentState(DRAWER_IDS.TEMPLATE_LOGS_FILTER);
    this.destroy$.next();
    this.destroy$.complete();
  }
}
